import React from "react";
import { SvgIcon } from "@mui/material";
import { ToggleableIconProps } from "../../../../types/IconProps";
import { useTheme } from "@mui/material/styles";
import { getIconColor } from "../../../../services/iconService";

const IconLicencePointsFive = ({ active = false, sx = {} }: ToggleableIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon sx={sx} viewBox="0 0 300 300">
      <g style={{ fill: getIconColor(active, theme) }}>
        <path
          d="M153.471,130.05c-5.683,0-14.106,2.057-19.149,7.195v-29.154h40.231V94.509h-56.397v51.385l16.119,7.197
			c2.043-4.994,8.299-9.574,15.559-9.574c11.762,0,19.15,11.17,19.15,23.49c0,14.682-8.426,24.816-22.82,24.816
			c-10.611,0-15.958-5.73-19.325-10.854l-12.063,9.098c7.309,9.719,18.783,15.367,32.154,15.367c19.613,0,38.3-13.213,38.3-38.299
			c0-22.168-13.372-36.992-31.677-36.992L153.471,130.05z"
        />
        <path
          d="M29.485,287.126c-9.121-0.031-16.556-7.467-16.586-16.576V65.908c0-1.906,1.547-3.453,3.455-3.453
			c1.906,0,3.453,1.547,3.453,3.453v204.631c0.018,5.314,4.363,9.662,9.688,9.68h241.006c5.321-0.014,9.672-4.359,9.688-9.689
			V29.462c-0.018-5.318-4.367-9.666-9.697-9.68H29.496c-5.325,0.018-9.672,4.363-9.688,9.689v13.246
			c0,1.908-1.547,3.455-3.453,3.455c-1.908,0-3.455-1.547-3.455-3.455V29.46c0.03-9.117,7.459-16.551,16.563-16.586
			c0.008,0,0.017,0,0.022,0h241.018c9.126,0.021,16.566,7.457,16.598,16.576v241.088c-0.03,9.129-7.472,16.564-16.588,16.588H29.485
			z"
        />
      </g>
      <g>
        <path
          fill={theme.palette.primary.main}
          d="M266.124,269.564H33.874c-1.907,0-3.454-1.547-3.454-3.455c0-1.906,1.547-3.453,3.454-3.453H262.67V33.847
			c0-1.906,1.547-3.453,3.454-3.453s3.454,1.547,3.454,3.453v232.262C269.578,268.017,268.03,269.564,266.124,269.564z"
        />
      </g>
    </SvgIcon>
  );
};

export default IconLicencePointsFive;
